/*
 *
 * UserInformation reducer
 *
 */

import { fromJS } from 'immutable';
import {
  FETCH_DEFAULT_CARD,
  FETCH_DEFAULT_CARD_ERROR,
  FETCH_DEFAULT_CARD_SUCCESS,
  UPDATE_DEFAULT_CARD,
  UPDATE_DEFAULT_CARD_SUCCESS,
  UPDATE_DEFAULT_CARD_ERROR,
} from './constants';

export const initialState = fromJS({
  loading: 'false',
  defaultCard: {},
  failedAppointments: [],
});

function failedPaymentsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DEFAULT_CARD:
      return state.set('loading', false);
    case FETCH_DEFAULT_CARD_ERROR:
      return state.set('loading', false).set('error', action.error);
    case FETCH_DEFAULT_CARD_SUCCESS:
      return state
        .set('loading', false)
        .mergeDeep({ defaultCard: action.card });
    case UPDATE_DEFAULT_CARD:
      return state.set('loading', false);
    case UPDATE_DEFAULT_CARD_ERROR:
      return state.set('loading', false).set('error', action.error);
    case UPDATE_DEFAULT_CARD_SUCCESS:
      return state
        .set('loading', false)
        .mergeDeep({ defaultCard: action.card });
    default:
      return state;
  }
}

export default failedPaymentsReducer;
